import React from "react";
import { Row, Col } from "react-bootstrap";
import { connect } from "react-redux";
import { reducerKeys } from "../../../../store/reducers/reducer";
import ContractsChart from "../charts/ContractsChart";
import {
  Card,
  CardTitle,
  RenderItemContainer,
  RenderDoughnutValue,
  RenderValue,
} from "../components";
import styles from "../GeneralPanelPage.module.css";

function FourthGroup({ colProps, infos, loading }) {
  return (
    <Card colProps={colProps}>
      <CardTitle title="CONTRATOS" />
      <Row className="m-0">
        <div className={styles.doughnutContainer}>
          <ContractsChart chartData={loading ? null : infos.chartData} />
        </div>
        <Col xs className="pr-3">
          <RenderItemContainer className="flex-column">
            <RenderItemContainer withBorder className="w-100 p-2 px-3">
              <RenderValue
                subtitle={
                  loading
                    ? null
                    : infos.subscriptionPending +
                      infos.signedContracts +
                      infos.canceled
                }
                title="Total"
              />
            </RenderItemContainer>
            <Row className="w-100 d-flex justify-content-center px-3 pb-3 pt-2">
              <div className="d-flex flex-row flex-wrap justify-content-between pr-1 w-100">
                <RenderDoughnutValue
                  title="Pendentes de assinatura"
                  subtitle={loading ? null : infos.subscriptionPending}
                  dotColor="#FFC107"
                />
                <RenderDoughnutValue
                  title="Assinados"
                  subtitle={loading ? null : infos.signedContracts}
                  dotColor="#2ECC71"
                />
                <RenderDoughnutValue
                  title="Cancelados"
                  subtitle={loading ? null : infos.canceled}
                  dotColor="#F0166D"
                />
              </div>
            </Row>
          </RenderItemContainer>
        </Col>
      </Row>
    </Card>
  );
}

function stateToProps(state) {
  const { fourthGroupInfos, fourthGroupLoading } =
    state[reducerKeys.generalPanel];
  return { infos: fourthGroupInfos, loading: fourthGroupLoading };
}

export default connect(stateToProps)(FourthGroup);
